var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var assetPath = process.env.PUBLIC_URL + '/assets';
export function AssetImage(props) {
    var assetSrc = assetPath + "/" + props.src;
    var assetAlt = props.alt ? props.alt : '';
    return (_jsx("img", __assign({}, props, { src: assetSrc, alt: assetAlt }, { children: props.children })));
}
